import { render, staticRenderFns } from "./MText.vue?vue&type=template&id=3bbc646c&scoped=true"
import script from "./MText.vue?vue&type=script&lang=js"
export * from "./MText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc646c",
  null
  
)

export default component.exports